import React from 'react';
import { Typography, Card, Divider } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

const { Title, Paragraph, Text } = Typography;

const PrivacyPage = () => {
  return (
    <div style={{ maxWidth: 900, margin: '0 auto', padding: '24px' }}>
      <Card>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <LockOutlined style={{ fontSize: 48, color: '#1890ff' }} />
          <Title level={2} style={{ marginTop: 16 }}>
            Δήλωση Προστασίας Προσωπικών Δεδομένων
          </Title>
          <Text type="secondary">Τελευταία ενημέρωση: 30/04/2026</Text>
        </div>

        <Title level={4}>1. ΕΙΣΑΓΩΓΗ</Title>
        <Paragraph>
          Στην animap (εφεξής «animap», «εμείς», «εμάς» ή «μας») σεβόμαστε την προστασία της ιδιωτικής σας ζωής και των δεδομένων προσωπικού χαρακτήρα που μας κοινοποιείτε ή που με άλλο τρόπο συλλέγουμε μέσω της ιστοσελίδας animap.gr και της σχετικής διαδικτυακής πλατφόρμας της animap (εφεξής συνολικά η «Ιστοσελίδα»).
        </Paragraph>
        <Paragraph>
          Η παρούσα Δήλωση αποτελεί ενιαίο κείμενο με τους <Link to="/terms">Όρους Χρήσης και Παροχής Υπηρεσιών</Link> της Ιστοσελίδας. Για τους επαγγελματίες χρήστες, ισχύουν ταυτόχρονα τα οριζόμενα στους <Link to="/business-terms">Όρους και Προϋποθέσεις Προβολής Επιχειρήσεων</Link>.
        </Paragraph>

        <Divider />

        <Title level={4}>2. ΥΠΕΥΘΥΝΟΣ ΕΠΕΞΕΡΓΑΣΙΑΣ</Title>
        <Paragraph>
          Υπεύθυνος επεξεργασίας των προσωπικών σας δεδομένων, σύμφωνα με το σχετικό ορισμό του GDPR, είναι η εταιρεία «Monovia Ι.Κ.Ε.», με αρ. ΓΕΜΗ: 186347801000 και ΑΦΜ: 802964751, η οποία εδρεύει στην Αθήνα, οδός Δώρου αρ. 2, 10431.
        </Paragraph>
        <Paragraph>
          Μπορείτε να επικοινωνήσετε με τον υπεύθυνο επεξεργασίας ανά πάσα στιγμή, αποστέλλοντας μήνυμα ηλεκτρονικού ταχυδρομείου στην ηλεκτρονική διεύθυνση: <a href="mailto:legal@animap.gr">legal@animap.gr</a>.
        </Paragraph>

        <Divider />

        <Title level={4}>3. ΑΝΗΛΙΚΟΙ</Title>
        <Paragraph>
          Η Ιστοσελίδα δεν προορίζεται για χρήση από ανήλικους. Σε καμία περίπτωση δεν συλλέγουμε εν γνώσει μας προσωπικά δεδομένα ανηλίκων κάτω των 15 ετών, χωρίς την συγκατάθεση από τον γονέα ή τον κηδεμόνα τους.
        </Paragraph>

        <Divider />

        <Title level={4}>4. ΥΠΟΚΕΙΜΕΝΑ ΤΩΝ ΔΕΔΟΜΕΝΩΝ</Title>
        <Paragraph>
          Οι προσωπικές πληροφορίες που συλλέγουμε και επεξεργαζόμαστε αφορούν τις παρακάτω κατηγορίες υποκειμένων:
        </Paragraph>
        <ul>
          <li>Χρήστες που περιηγούνται στην Ιστοσελίδα</li>
          <li>Χρήστες της Ιστοσελίδας που κάνουν εγγραφή για πρόσβαση στις υπηρεσίες</li>
          <li>Επαγγελματίες χρήστες και επιχειρήσεις που προβάλλονται στην Ιστοσελίδα</li>
        </ul>

        <Divider />

        <Title level={4}>5. ΚΑΤΗΓΟΡΙΕΣ ΠΡΟΣΩΠΙΚΩΝ ΔΕΔΟΜΕΝΩΝ</Title>
        <Paragraph>
          Τα προσωπικά δεδομένα που επεξεργαζόμαστε ή ενδέχεται να επεξεργαστούμε περιλαμβάνουν:
        </Paragraph>
        <ul>
          <li>Ονοματεπώνυμο</li>
          <li>Διεύθυνση κατοικίας</li>
          <li>E-mail</li>
          <li>Αριθμός κινητού τηλεφώνου</li>
          <li>Στοιχεία πιστωτικής/χρεωστικής κάρτας</li>
          <li>Δεδομένα λογαριασμού Χρήστη και ιστορικού χρήσης</li>
          <li>Δεδομένα περιήγησης στην Ιστοσελίδα</li>
          <li>Αναγνωριστικά στοιχεία και πληροφορίες συσκευής</li>
        </ul>
        <Paragraph>
          Ειδικά για τους επαγγελματίες και τις επιχειρήσεις που προβάλλονται στην Ιστοσελίδα, επιπλέον συλλέγουμε: Επωνυμία επιχείρησης, Διεύθυνση επιχείρησης, ΑΦΜ, Ρόλος/ιδιότητα στην εταιρεία, Δικαιολογητικά που πιστοποιούν τη δυνατότητα παροχής υπηρεσιών.
        </Paragraph>

        <Divider />

        <Title level={4}>6. ΣΚΟΠΟΙ ΕΠΕΞΕΡΓΑΣΙΑΣ</Title>
        <Paragraph>
          Τα προσωπικά σας δεδομένα συλλέγονται και επεξεργάζονται για τους εξής σκοπούς:
        </Paragraph>
        <ul>
          <li>Δημιουργία και διαχείριση λογαριασμού χρήστη</li>
          <li>Παροχή των υπηρεσιών της πλατφόρμας</li>
          <li>Επεξεργασία παραγγελιών και πληρωμών</li>
          <li>Επικοινωνία σχετικά με ραντεβού και παραγγελίες</li>
          <li>Βελτίωση της εμπειρίας χρήστη</li>
          <li>Συμμόρφωση με νομικές υποχρεώσεις</li>
        </ul>

        <Divider />

        <Title level={4}>7. ΤΑ ΔΙΚΑΙΩΜΑΤΑ ΣΑΣ</Title>
        <Paragraph>
          Σύμφωνα με τον GDPR, έχετε τα εξής δικαιώματα:
        </Paragraph>
        <ul>
          <li>Δικαίωμα πρόσβασης στα προσωπικά σας δεδομένα</li>
          <li>Δικαίωμα διόρθωσης ανακριβών δεδομένων</li>
          <li>Δικαίωμα διαγραφής («δικαίωμα στη λήθη»)</li>
          <li>Δικαίωμα περιορισμού της επεξεργασίας</li>
          <li>Δικαίωμα φορητότητας των δεδομένων</li>
          <li>Δικαίωμα εναντίωσης</li>
          <li>Δικαίωμα ανάκλησης της συγκατάθεσης</li>
        </ul>
        <Paragraph>
          Για την άσκηση οποιουδήποτε δικαιώματος, επικοινωνήστε μαζί μας στο <a href="mailto:legal@animap.gr">legal@animap.gr</a>.
        </Paragraph>

        <Divider />

        <Title level={4}>8. ΑΣΦΑΛΕΙΑ ΔΕΔΟΜΕΝΩΝ</Title>
        <Paragraph>
          Εφαρμόζουμε κατάλληλα τεχνικά και οργανωτικά μέτρα για την προστασία των προσωπικών σας δεδομένων από μη εξουσιοδοτημένη πρόσβαση, απώλεια ή καταστροφή.
        </Paragraph>

        <Divider />

        <Title level={4}>9. ΧΡΟΝΟΣ ΔΙΑΤΗΡΗΣΗΣ</Title>
        <Paragraph>
          Διατηρούμε τα προσωπικά σας δεδομένα για όσο χρονικό διάστημα απαιτείται για την εκπλήρωση των σκοπών για τους οποίους συλλέχθηκαν ή για όσο χρονικό διάστημα απαιτείται από την ισχύουσα νομοθεσία.
        </Paragraph>

        <Divider />

        <Title level={4}>10. ΕΠΙΚΟΙΝΩΝΙΑ</Title>
        <Paragraph>
          Για ερωτήσεις σχετικά με την παρούσα Δήλωση ή την επεξεργασία των προσωπικών σας δεδομένων, επικοινωνήστε μαζί μας:
        </Paragraph>
        <Paragraph>
          Email: <a href="mailto:legal@animap.gr">legal@animap.gr</a><br />
          Διεύθυνση: Δώρου 2, 10431 Αθήνα
        </Paragraph>

        <Divider />

        <Paragraph type="secondary" style={{ textAlign: 'center' }}>
          Δείτε επίσης: <Link to="/terms">Όροι Χρήσης</Link> | <Link to="/cookies">Πολιτική Cookies</Link>
        </Paragraph>
      </Card>
    </div>
  );
};

export default PrivacyPage;
